/**
 * The one switch for a player who cannot take a moving picture.
 *
 * It writes the master in [motionPreference](../../../core/motion/motionPreference.ts), which is
 * what every motion asks before it draws itself. The three knobs under it are still their own
 * switches and still say what they are set to; this one wins over all of them, because somebody
 * being made ill by the game does not yet know which of the three is doing it and should not have
 * to find out before they can play.
 *
 * The default is the operating system's own answer, not `off`. A player who has already turned
 * motion down machine-wide has said this once and should not have to say it again through a screen
 * they would have to survive the menu to reach. The moment they touch the switch their answer is
 * stored on the character and wins for good.
 */

import { DEFAULT_MOTION_REDUCED, setMotionReduced } from '@/core/motion/motionPreference';
import { SETTING_MOTION_REDUCTION_HINT, SETTING_MOTION_REDUCTION_LABEL } from '@/text/settingsText';
import { toggleApply, toggleValue } from '@/ui/settings/controls/toggleSwitch';
import type { SettingDefinition } from '@/ui/settings/settingContract';

export const MOTION_REDUCTION: SettingDefinition = {
  id: 'motionReduction',
  section: 'accessibility',
  label: SETTING_MOTION_REDUCTION_LABEL,
  hint: SETTING_MOTION_REDUCTION_HINT,
  control: { kind: 'toggle' },
  defaultValue: toggleValue(DEFAULT_MOTION_REDUCED),
  apply: toggleApply(setMotionReduced),
};
